import React from 'react';
import {ContentSlider} from '../MBBeVoContentSliderWeb/ContentSlider';
import './MBBeVoContentSlider.css';

import {CATEGORY_PROPS} from '../../../../globals/Constants';

const MBBeVoContentSlider = () => {
    return (
        <div className=''>
            {/* Slider for Web and Tablets >= 768px */}
            <div className='MBBeVoContentSlider-web-tab'>
                <ContentSlider content={CATEGORY_PROPS}></ContentSlider>
            </div>
            {/* Slider for mobile devices < 768px */}
            <div className='MBBeVoContentSlider-mobile MBBeVoContentSlider-mobile-space'>
                <ContentSlider content={CATEGORY_PROPS}></ContentSlider>
            </div>
        </div>
    );
};

export default MBBeVoContentSlider;
